export default __webpack_public_path__ + "static/media/vol4_2.a5e1b816.png";